import styled from 'styled-components';
import { Form } from 'informed';

export const FormContainer = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DivSelectForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
`;

export const DivFather = styled.div`
  width: 100%;
  margin-top: 24px;
  background: #fafafb;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const DivConteiner = styled.div`
  width: 1000px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
`;

export const DivBody = styled.div`
  width: 100%;
  height: 100%;
`;

export const DivHeaderForm = styled.div`
  width: 100%;
  display: flex;
  height: 308px;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  background: #f4f4f4;
`;

export const SpanTitle = styled.span`
  margin-left: 15px;
  color: #727780;
  font-family: Public Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 26px;
  margin-top: 19px;
`;

export const DivButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 40px;
`;

export const ButtonSubmit = styled.button`
  width: 165px;
  height: 42px;
  border-radius: 24px;
  background: #0047b6;
  border: transparent;

  color: #fff;
  text-align: center;
  font-family: Public Sans;
  font-size: 14px;
  font-weight: 700;
`;

export const ButtonCancelar = styled.button`
  width: 126px;
  height: 40px;
  border-radius: 24px;
  border: 1px solid #0047b6;
  background: transparent;

  color: #0047b6;
  font-family: Public Sans;
  font-size: 14px;
  font-weight: 900;
`;
